
interface HabitGridEditNoticeProps {
  visible: boolean;
}

export default function HabitGridEditNotice({ visible }: HabitGridEditNoticeProps) {
  if (!visible) return null;
  
  return (
    <div className="text-sm text-muted-foreground mb-4 bg-accent/50 p-3 rounded-md">
      Edit mode: Click on dates to add or remove them. Click "Save" when you're done.
    </div>
  );
}
